// JavaScript
import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[employeeApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[employeeApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    // Список сотрудников: пагинация page и поиск q
    async getEmployees({ page = 1, page_size, q, is_active } = {}) {
        const params = {};
        if (page) params.page = page;
        if (page_size) params.page_size = page_size;
        if (q) params.q = q;
        // корректно добавляем флаг архива/активных
        if (typeof is_active === 'boolean') params.is_active = is_active;

        try {
            const response = await axiosInstance.get('employees/', { params });
            return response.data; // { count, next, previous, results }
        } catch (error) {
            logAndRethrow('GET employees/', error);
        }
    },


    // Детали сотрудника
    async getEmployee(id) {
        try {
            const response = await axiosInstance.get(`employees/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET employees/${id}/`, error);
        }
    },

    // События: /api/{target}/{id}/events/?page=...
    async getEvents({ target = 'user', id, page = 1 }) {
        try {
            const response = await axiosInstance.get(`${target}/${id}/events/`, { params: { page } });
            return response.data; // { count, next, previous, results }
        } catch (error) {
            logAndRethrow(`GET ${target}/${id}/events/`, error);
        }
    },

    // === Справочники для формы ===
    async getDepartments() {
        try {
            const response = await axiosInstance.get('employees/departments/');
            return response.data;
        } catch (error) {
            logAndRethrow('GET employees/departments/', error);
        }
    },

    async getPositions({ page = 1, department = null } = {}) {
        const params = { page };
        if (department) {
            params.department = department;
        }
        try {
            const response = await axiosInstance.get('employees/positions/', { params });
            return response.data;
        } catch (error) {
            logAndRethrow('GET employees/positions/', error);
        }
    },



    // === Создание/обновление ===
    async createEmployee(formData) {
        try {
            // multipart/form-data будет автоматически выставлен axios
            const response = await axiosInstance.post('employees/create/', formData);
            return response.data;
        } catch (error) {
            logAndRethrow('POST employees/create/', error);
        }
    },

    async updateEmployee(id, formData) {
        try {
            const response = await axiosInstance.patch(`employees/${id}/`, formData);
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH employees/${id}/`, error);
        }
    },
    // Деактивация сотрудника (is_active = false)
    async deactivateEmployee(id) {
        try {
            const response = await axiosInstance.post(`employees/${id}/deactivate/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST employees/${id}/deactivate/`, error);
        }
    },

    // POST /api/employees/{id}/unarchive/ (разархивация / активация)
    async unarchiveEmployee(id) {
        try {
            const response = await axiosInstance.post(`employees/${id}/unarchive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST employees/${id}/unarchive/`, error);
        }
    },

    async getCurrentUser() {
        try {
            const response = await axiosInstance.get('employees/me/');
            return response.data; // { id, username, email, first_name, last_name, full_name, avatar, department, post, groups, permissions }
        } catch (error) {
            logAndRethrow('GET employees/me/', error);
        }
    },

    // === CRUD для Departments ===
    async createDepartment(data) {
        try {
            const response = await axiosInstance.post('employees/departments/', data);
            return response.data;
        } catch (error) {
            logAndRethrow('POST employees/departments/', error);
        }
    },

    async getDepartment(id) {
        try {
            const response = await axiosInstance.get(`employees/departments/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET employees/departments/${id}/`, error);
        }
    },

    async updateDepartment(id, data) {
        try {
            const response = await axiosInstance.put(`employees/departments/${id}/`, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`PUT employees/departments/${id}/`, error);
        }
    },

    async patchDepartment(id, data) {
        try {
            const response = await axiosInstance.patch(`employees/departments/${id}/`, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH employees/departments/${id}/`, error);
        }
    },

    async deleteDepartment(id) {
        try {
            const response = await axiosInstance.delete(`employees/departments/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE employees/departments/${id}/`, error);
        }
    },

    // === CRUD для Positions ===
    async createPosition(data) {
        try {
            const response = await axiosInstance.post('employees/positions/', data);
            return response.data;
        } catch (error) {
            logAndRethrow('POST employees/positions/', error);
        }
    },

    async getPosition(id) {
        try {
            const response = await axiosInstance.get(`employees/positions/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET employees/positions/${id}/`, error);
        }
    },

    async updatePosition(id, data) {
        try {
            const response = await axiosInstance.put(`employees/positions/${id}/`, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`PUT employees/positions/${id}/`, error);
        }
    },

    async patchPosition(id, data) {
        try {
            const response = await axiosInstance.patch(`employees/positions/${id}/`, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH employees/positions/${id}/`, error);
        }
    },

    async deletePosition(id) {
        try {
            const response = await axiosInstance.delete(`employees/positions/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE employees/positions/${id}/`, error);
        }
    },

    // === Permissions ===
    async getDepartmentPermissions(departmentId) {
        try {
            const response = await axiosInstance.get(`employees/departments/${departmentId}/permissions/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET employees/departments/${departmentId}/permissions/`, error);
        }
    },

    async updateDepartmentPermissions(departmentId, permissions) {
        try {
            const response = await axiosInstance.patch(`employees/departments/${departmentId}/permissions/`, {
                permissions
            });
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH employees/departments/${departmentId}/permissions/`, error);
        }
    },

    async getUserPermissions(userId) {
        try {
            const response = await axiosInstance.get(`employees/${userId}/permissions/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET employees/${userId}/permissions/`, error);
        }
    },

    async updateUserPermissions(userId, { extra_permissions, revoked_permissions }) {
        try {
            const response = await axiosInstance.patch(`employees/${userId}/permissions/`, {
                extra_permissions,
                revoked_permissions
            });
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH employees/${userId}/permissions/`, error);
        }
    },

    async getPositionPermissions(positionId) {
        try {
            const response = await axiosInstance.get(`employees/positions/${positionId}/permissions/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET employees/positions/${positionId}/permissions/`, error);
        }
    },

    async updatePositionPermissions(positionId, permissions) {
        try {
            const response = await axiosInstance.patch(`employees/positions/${positionId}/permissions/`, {
                permissions
            });
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH employees/positions/${positionId}/permissions/`, error);
        }
    },

};
